import { env } from 'src/config/env';

/**
 * Deploy identifier stamped into RUM `release` and logger context.
 *
 * CI sets `VITE_APP_BUILD_ID` at build time (`<short-sha>-<pipeline-id>`).
 * Local dev falls back to `local` so ops telemetry is distinguishable from deploys.
 *
 * @returns {string}
 */
export const getApplicationRelease = () => {
    if (env.buildId) {
        return env.buildId;
    }

    if (env.environment === 'local') {
        return 'local';
    }

    return 'unknown';
};
